import { UNUSED_PARAMETER } from 'hooks/metrics/shared/constants';

import {
  CONTENT_SECTION,
  CONTENT_TYPE,
  CONTENT_CATEGORY,
  AUTHPN,
} from '../constants';

/**
 * Devuelve los valores fijos del modo Mundial para fase 1:
 *  - Hardcodes (content_section, content_type, content_category, authpn)
 *  - Campos en "no aplica" (UNUSED_PARAMETER) que en fase 2 se llenarán
 *    con datos reales de cada partido/contenido.
 *
 * IMPORTANTE: este es el único lugar que cambiará en fase 2 cuando
 * tengamos los valores reales (content_id, content_name, etc.).
 */
export const buildMundialDefaults = ({ contentSection } = {}) => ({
  content_section: contentSection || CONTENT_SECTION,
  content_type: CONTENT_TYPE,
  content_category: CONTENT_CATEGORY,
  authpn: AUTHPN,

  // Fase 1: estos campos van como "no aplica".
  // Fase 2: reemplazar con los valores reales del partido/contenido.
  content_id: UNUSED_PARAMETER,
  content_name: UNUSED_PARAMETER,
  content_availability: UNUSED_PARAMETER,
  provider: UNUSED_PARAMETER,
  content_location: UNUSED_PARAMETER,
  content_start_date: UNUSED_PARAMETER,
  final_score: UNUSED_PARAMETER,
  match_winner: UNUSED_PARAMETER,
  match_time: UNUSED_PARAMETER,
});
